import styled from 'styled-components'
import sizes from '../../styles/sizes'
import fonts from '../../styles/fonts'

export const TabsContainer = styled.div`
        display: flex;
        width: 100%;
        flex-direction: row;
        border-bottom: 1px solid ${props => props.theme.colors.greys.dividerGray};
        margin-bottom: 15px;
        @media (max-width: ${sizes.breakPoints.small}) {
           width: 100%;
           justify-content: flex-start;
           flex-wrap: nowrap;
           overflow-x: auto;
           -webkit-overflow-scrolling: touch;
           scrollbar-width: none;
           &::-webkit-scrollbar { display: none; }
        }
`


export const TabButton = styled.button`
        max-width: 140px;
        text-align: left;
        white-space: nowrap;
	padding: 9px 16px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 14px;
	font-weight: ${props => (props.$active ? fonts.fontWeight.semibold : fonts.fontWeight.regular)};
	color: ${props =>
		props.$active ? props.theme.colors.text.titleText : props.theme.colors.text.mutedText};
	border-bottom: 2px solid ${props => (props.$active ? props.theme.colors.brand.lightBlue : 'transparent')};
	margin-bottom: -1px;
	transition: color 0.2s ease, border-color 0.2s ease;
        @media (max-width: ${sizes.breakPoints.small}) {
          flex: 1 0 auto;
          width: auto;
          min-width: 0;
          max-width: none;
          text-align: left;
        }
`
